import { render, staticRenderFns } from "./ELink.vue?vue&type=template&id=2fa393ee&scoped=true&"
import script from "./ELink.vue?vue&type=script&lang=js&"
export * from "./ELink.vue?vue&type=script&lang=js&"
import style0 from "./ELink.vue?vue&type=style&index=0&id=2fa393ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa393ee",
  null
  
)

export default component.exports